import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import {
  isValid,
  REQUIRED,
  validate,
} from "../../utils/Validation";
import SelectField from "../../components/SelectField";
import { listCategoriesByDrinkId } from "../../api/Category";
import { ATTRIBUTE_TYPES, TRAIT_TYPE_LABEL, TRAIT_TYPE_OPTIONS, TRAIT_TYPES } from "../../constants/Consts";
import { getAllDrinks } from "../../api/Drink";
import { listAttributesByCategoryIdAndType } from "../../api/Attribute";
import ColorGradient from "../../components/ColorGradient";
import { listAllTraits } from "../../api/Trait";


export default function EditTrait({ selected, onClose, onSave }) {
  const [trait, setTrait] = useState({
    nameBr: "",
    type: "",
    hexColor: "",
    attribute: "",
    order: 0,
  });
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [drinkOptions, setDrinkOptions] = useState([]);
  const [selectedDrinkId, setSelectedDrinkId] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [attributeOptions, setAttributeOptions] = useState([]);
  const [selectedAttributeId, setSelectedAttributeId] = useState("");
  const [traitOptions, setTraitOptions] = useState([]);
  const [trait2Options, setTrait2Options] = useState([]);
  const [selectedTraitId, setSelectedTraitId] = useState("");
  const [selectedTrait2Id, setSelectedTrait2Id] = useState("");
  const [traitParent, setTraitParent] = useState();

  useEffect(() => {
    const load = async () => {
      const res = await getAllDrinks("nameBr", "ASC");
      setDrinkOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    load();
  }, []);

  useEffect(() => {
    const load = async () => {
      const res = await listCategoriesByDrinkId(selectedDrinkId);
      setCategoryOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    if(!!selectedDrinkId){
      load();
    } else{
      setCategoryOptions([]);
    }
    setSelectedCategoryId("");
    setSelectedAttributeId("");
    setSelectedTraitId("");
    setSelectedTrait2Id("");
  }, [selectedDrinkId]);

  useEffect(() => {
    const load = async () => {
      const res = await listAttributesByCategoryIdAndType(selectedCategoryId, ATTRIBUTE_TYPES.TRAIT);
      setAttributeOptions(res.map(r => ({ label: r.nameBr, value: r.id, data: r })));
    }

    if(!!selectedCategoryId){
      load();
    } else{
      setAttributeOptions([]);
    }
    setSelectedAttributeId("");
    setSelectedTraitId("");
    setSelectedTrait2Id("");
  }, [selectedCategoryId]);

  useEffect(() => {
    const load = async () => {
      const res = await listAllTraits(
        "order", 
        "ASC", 
        selectedAttributeId,
        null,
        null,
      );
      setTraitOptions(res.map(r => ({ label: r.nameBr, value: r.id, data: r })));
    }

    if(!!selectedAttributeId){
      load();
    } else{
      setTraitOptions([]);
    }
    setSelectedTraitId("");
    setSelectedTrait2Id("");
  }, [selectedAttributeId]);

  useEffect(() => {
    const load = async () => {
      const res = await listAllTraits(
        "order", 
        "ASC", 
        null,
        null,
        selectedTraitId,
      );
      setTrait2Options(res.map(r => ({ label: r.nameBr, value: r.id, data: r })));
    }

    if(!!selectedTraitId){
      load();
    } else{
      setTrait2Options([]);
    }
    setSelectedTrait2Id("");
  }, [selectedTraitId]);

  useEffect(() => {
    const getRoot = (trait) => {
      if(!!trait.parent){
        return getRoot(trait.parent);
      } else{
        return trait;
      }
    }
    
    setTrait(selected);
    setShow(selected != null);
    setErrors({});
    setSubmitting(false);
    if(!!selected){
      setTraitParent(getRoot(selected));
    } else{
      setTraitParent(undefined);
    }
    setSelectedDrinkId("");
    setSelectedCategoryId("");
    setSelectedAttributeId("");
    setSelectedTraitId("");
    setSelectedTrait2Id("");
  }, [selected]);

  const clear = () => {
    setTrait({
      nameBr: "",
      type: "",
      hexColor: "",
      attribute: null,
      order: 0,
    });
    setErrors({});
    setSubmitting(false);
    setSelectedDrinkId("");
    setSelectedCategoryId("");
    setSelectedAttributeId("");
    setSelectedTraitId("");
    setSelectedTrait2Id("");
  };

  const save = async () => {
    setSubmitting(true);
    const rules = {
      nameBr: REQUIRED,
      type: REQUIRED,
      order: REQUIRED,
    };
    const data = { ...trait }
    if(!!selectedTrait2Id){
      const t2 = trait2Options.find(t => t.value == selectedTrait2Id);
      data.parent = t2.data;
    } else if(!!selectedTraitId){
      const t1 = traitOptions.find(t => t.value == selectedTraitId);
      data.parent = t1.data;
    } else{
      if(!!selectedAttributeId){
        const attr = attributeOptions.find(a => a.value == selectedAttributeId);
        data.attribute = attr.data;
      }
      rules.attribute = REQUIRED;
    }
    
    if(data.type === TRAIT_TYPES.COLOR){
      rules.hexColor = REQUIRED;
    } else{
      data.hexColor = null;
    }
    const errors = await validate(rules, data);
    if (isValid(errors)) {
      onSave(data);
    } else {
      setErrors(errors);
    }
    setSubmitting(false);
  };

  const isTypeDisabled = () => {
    if(!!attributeOptions && !!selectedAttributeId){
      const attribute = attributeOptions.find(a => a.value == selectedAttributeId);
      return !!attribute?.data?.traits && attribute.data.traits.length > 0;
    }
    return false;
  }

  return (
    <Modal
      visible={show}
      onClose={() => {
        clear();
        onClose();
      }}
      title={trait?.id ? "Editar Característica" : "Nova Característica"}
      Action={<Button disabled={submitting} submitting={submitting} onClick={() => save()}>Cadastrar</Button>}
    >
      <TextField
        label="Nome (PT-BR)"
        className="mb-5"
        placeholder="Insira um nome"
        value={trait}
        field="nameBr"
        update={setTrait}
        errors={errors}
      />
      <TextField
        label="Posição"
        className="mb-5"
        placeholder="Insira a posição"
        value={trait}
        field="order"
        update={(data) => {
          data.order = data.order.replace(new RegExp("[^0-9]", "g"), "");
          setTrait(data);
        }}
        errors={errors}
      />
      { !!trait?.id ? (
        <>
          <TextField
            label="Bebida"
            className="mb-5"
            value={traitParent?.attribute?.category?.drink?.nameBr ?? ""}
            disabled={true}
          />
          <TextField
            label="Categoria"
            className="mb-5"
            value={traitParent?.attribute?.category?.nameBr ?? ""}
            disabled={true}
          />
          <TextField
            label="Atributo"
            className="mb-5"
            value={traitParent?.attribute?.nameBr ?? ""}
            disabled={true}
          />
          { !!trait?.parent?.parent &&
            <TextField
              label="Característica"
              className="mb-5"
              value={trait?.parent?.parent?.nameBr ?? ""}
              disabled={true}
            />
          }
          { !!trait?.parent &&
            <TextField
              label="Característica 2"
              className="mb-5"
              value={trait?.parent?.nameBr ?? ""}
              disabled={true}
            />
          }
          <TextField
            label="Tipo"
            className="mb-5"
            value={!!trait?.type ? TRAIT_TYPE_LABEL[trait.type] : ""}
            disabled={true}
          />
        </>
      ) : (
        <>
          <SelectField
            label="Bebida"
            className="mb-5"
            value={selectedDrinkId} 
            options={drinkOptions} 
            update={(v) => setSelectedDrinkId(v)} 
            errors={errors.drink}
          />
          <SelectField
            label="Categoria"
            className="mb-5"
            value={selectedCategoryId}
            options={categoryOptions}
            update={setSelectedCategoryId}
            errors={errors.category}
          />
          <SelectField
            label="Atributo"
            className="mb-5"
            value={selectedAttributeId}
            options={attributeOptions}
            update={(v) => {
              const attribute = attributeOptions.find(a => a.value == v);
              let type = "";
              if(!!attribute?.data?.traits && attribute.data.traits.length > 0){
                type = attribute.data.traits[0].type;
                setTrait(t => ({ ...t, ...{ type } }));
              }
              setSelectedAttributeId(v);
            }}
            errors={errors.attribute}
          />
          <SelectField
            label="Característica (Opcional)"
            className="mb-5"
            value={selectedTraitId}
            options={traitOptions}
            update={(v) => {
              const traitOption = traitOptions.find(t => t.value == v);
              let type = "";
              if(!!traitOption?.data?.traits && traitOption.data.traits.length > 0){
                type = traitOption.data.traits[0].type;
                setTrait(t => ({ ...t, ...{ type } }));
              }
              setSelectedTraitId(v);
            }}
            errors={errors.trait}
          />
          <SelectField
            label="Característica 2 (Opcional)"
            className="mb-5"
            value={selectedTrait2Id}
            options={trait2Options}
            update={(v) => {
              const trait2Option = trait2Options.find(t => t.value == v);
              let type = "";
              if(!!trait2Option?.data?.traits && trait2Option.data.traits.length > 0){
                type = trait2Option.data.traits[0].type;
                setTrait(t => ({ ...t, ...{ type } }));
              }
              setSelectedTrait2Id(v);
            }}
            errors={errors.trait2}
          />
          <SelectField
            label="Tipo"
            className="mb-5"
            update={setTrait}
            field="type"
            options={TRAIT_TYPE_OPTIONS}
            value={trait}
            disabled={isTypeDisabled()}
            errors={errors}
          />
        </>
      )}
      { trait?.type === ATTRIBUTE_TYPES.COLOR && (
        <>
          <TextField
            label="Cor"
            className="mb-5"
            placeholder="Insira a cor (Ex: #ffff00)"
            value={trait}
            field="hexColor"
            update={(data) => {
              data.hexColor = "#" + data.hexColor.replace(new RegExp("[^0-9a-fA-F]", "g"), "").toUpperCase().slice(0, 8);
              setTrait(data);
            }}
            errors={errors}
          />
          <ColorGradient
            start={trait?.hexColor}
            middle={trait?.hexColor}
            end={trait?.hexColor}
          />
        </>
      )}
      <div className="h-20" />
    </Modal>
  );
}
